export const STAGES = {
  INTRO_PAGE: '0_intro_page',
  SETUP_IN_PROGRESS_PAGE: '0_setup_in_progress',
  AUTOMATIC_SETUP_NOT_POSSIBLE: '0_automatic_setup_not_possible',
  PMS_SELECTION_PAGE: '1_pms_selection',
  PMS_ELIGIBILITY_QUESTIONS_PAGE: '1_eligibility_question',
  OTHER_SYSTEM_SELECTION_PAGE: '1_1_other_system_selection',
  OTHER_SYSTEM_SELECTION_PREFILLED_PAGE:
    '1_1_1_other_system_selection_prefilled',
  OTHER_SYSTEM_ELIGIBILITY_QUESTIONS_PAGE:
    '1_2_other_system_eligibility_question',
  PMS_SETUP_PAGE: '2_pms_setup',
  PMS_UNSUPPORTED_PAGE: '2_pms_unsupported',
  BENCHMARK_QUESTION_PAGE: '3_benchmarking_question',
  VALIDATING_DATA_PAGE: '3_validating_data',
  INTEGRATION_ACTIVE_PAGE: '4_integration_active',
} as const;
export type Stage = (typeof STAGES)[keyof typeof STAGES];

export const ROUTE_NAME_FOR_STAGE_EDITORS = {
  [STAGES.INTRO_PAGE]: 'hotel.settings.myotb.intro',
  [STAGES.AUTOMATIC_SETUP_NOT_POSSIBLE]:
    'hotel.settings.myotb.intro.contact-support',
  [STAGES.PMS_SELECTION_PAGE]: 'hotel.settings.myotb.pms-selection',
  [STAGES.PMS_ELIGIBILITY_QUESTIONS_PAGE]:
    'hotel.settings.myotb.pms-eligibility',
  [STAGES.OTHER_SYSTEM_SELECTION_PAGE]:
    'hotel.settings.myotb.other-system-selection',
  [STAGES.OTHER_SYSTEM_SELECTION_PREFILLED_PAGE]:
    'hotel.settings.myotb.other-system-selection',
  [STAGES.OTHER_SYSTEM_ELIGIBILITY_QUESTIONS_PAGE]:
    'hotel.settings.myotb.other-system-eligibility',
  [STAGES.PMS_SETUP_PAGE]: 'hotel.settings.myotb.pms-setup',
  [STAGES.BENCHMARK_QUESTION_PAGE]: 'hotel.settings.myotb.benchmark',
  [STAGES.VALIDATING_DATA_PAGE]: 'hotel.settings.myotb.validation',
  [STAGES.INTEGRATION_ACTIVE_PAGE]: 'hotel.settings.myotb.active',
  [STAGES.PMS_UNSUPPORTED_PAGE]: 'hotel.settings.myotb.pms-unsupported',
  [STAGES.SETUP_IN_PROGRESS_PAGE]: 'hotel.settings.myotb.in-progress',
} as const;

export const ROUTE_NAME_FOR_STAGE_VIEWERS = {
  [STAGES.INTRO_PAGE]: 'hotel.settings.myotb.intro.contact-admin',
  [STAGES.AUTOMATIC_SETUP_NOT_POSSIBLE]:
    'hotel.settings.myotb.intro.contact-support',
  [STAGES.PMS_SELECTION_PAGE]: 'hotel.settings.myotb.in-progress',
  [STAGES.PMS_ELIGIBILITY_QUESTIONS_PAGE]: 'hotel.settings.myotb.in-progress',
  [STAGES.OTHER_SYSTEM_SELECTION_PAGE]: 'hotel.settings.myotb.in-progress',
  [STAGES.OTHER_SYSTEM_SELECTION_PREFILLED_PAGE]:
    'hotel.settings.myotb.in-progress',
  [STAGES.OTHER_SYSTEM_ELIGIBILITY_QUESTIONS_PAGE]:
    'hotel.settings.myotb.in-progress',
  [STAGES.PMS_SETUP_PAGE]: 'hotel.settings.myotb.in-progress',
  [STAGES.BENCHMARK_QUESTION_PAGE]: 'hotel.settings.myotb.in-progress',
  [STAGES.VALIDATING_DATA_PAGE]: 'hotel.settings.myotb.in-progress',
  [STAGES.INTEGRATION_ACTIVE_PAGE]: 'hotel.settings.myotb.active',
  [STAGES.PMS_UNSUPPORTED_PAGE]: 'hotel.settings.myotb.pms-unsupported',
  [STAGES.SETUP_IN_PROGRESS_PAGE]: 'hotel.settings.myotb.in-progress',
} as const;

// ID used for the other option in the PMS & other system selection dropdowns.
export const OTHER_OPTION_ID = -1;

export const ELIGIBILITY_QUESTION_TYPES = {
  SINGLE: 'single',
  MULTIPLE: 'multiple',
} as const;
export type EligibilityQuestionType =
  (typeof ELIGIBILITY_QUESTION_TYPES)[keyof typeof ELIGIBILITY_QUESTION_TYPES];

export const SETUP_STEP_TYPES = {
  CONFIRM: 'confirm',
  INTEGER: 'integer',
  STRING: 'string',
  BOOLEAN: 'boolean',
} as const;
export type SetupStepType =
  (typeof SETUP_STEP_TYPES)[keyof typeof SETUP_STEP_TYPES];

// Products the user can use to enter the Self service flow
export const OTB_SS_VIA_QP_VALUES = {
  OVERVIEW_DASHBOARD: 'Overview',
  MARKET_INSIGHT: 'Market Insight',
  RATE_INSIGHT: 'Rate Insight',
  PRICING_ASSISTANT: 'Pricing Assistant',
} as const;
export type OTBSSViaQPValue =
  (typeof OTB_SS_VIA_QP_VALUES)[keyof typeof OTB_SS_VIA_QP_VALUES];

export const OTB_SS_ENTRY_POINTS = {
  OD_OCCUPANCY: 'Occupancy',
  OD_PERFORMANCE_RATES_CHART: 'Performance rates chart',
  OD_ALERTS: 'Alerts',
  OD_KEY_DATES: 'Key dates',
  OD_DASHBOARD_FEED: 'Dashboard feed',
  OD_EVENTS: 'Events',
  OD_SETTINGS: 'Settings',
  RATES_EVOLUTION_CHART: 'Rates evolution chart',
  RATES_PACE_CHART: 'Rates pace chart',
  RATES_CALENDAR: 'Rates calendar',
  RATES_CHART: 'Rates chart',
  RATES_TABLE: 'Rates table',
  RATES_CALENDAR_SETTINGS_MODAL: 'Rates calendar settings modal',
  MI_OCCUPANCY_CARD: 'MI occupancy card',
  MI_OCCUPANCY_CHART: 'MI occupancy chart',
  RENTAL_EVOLUTION_CHART: 'Short-term rental evolution chart',
  RENTAL_CARD: 'Short-term rental card',
  RECOMMENDATIONS_SETTINGS: 'Recommendations settings',
  PRICING_ASSISTANT_CALENDAR: 'Pricing assistant calendar',
} as const;
export type OTBSSEntryPoint =
  (typeof OTB_SS_ENTRY_POINTS)[keyof typeof OTB_SS_ENTRY_POINTS];
